module.exports = __webpack_public_path__ + "static/media/ios-more.fe804481.svg";